"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const Info_1 = __importDefault(require("@material-ui/icons/Info"));
const clsx_1 = __importDefault(require("clsx"));
const theme_1 = require("../../styles/theme");
const icons_1 = require("../../icons");
const Iso_1 = __importDefault(require("@material-ui/icons/Iso"));
const utils_1 = require("../../utils");
const useLabelStyles = core_1.makeStyles((theme) => core_1.createStyles({
    labelWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 10,
        lineHeight: '18px',
        [theme.breakpoints.down(utils_1.MOBILE_BREAKPOINT)]: {
            display: 'block',
        }
    },
    instruction: {
        padding: 0,
        marginInline: 5,
        '& svg': {
            width: 20,
            height: 20,
            color: theme.palette.primary.main,
        },
        '&.sticky': {
            outline: 'auto',
        },
    },
    instructionAlertContainer: {
        position: 'relative',
        '@media (max-width: 767px)': {
            maxWidth: '50%',
        },
        '@media (min-width: 768px)': {
            minWidth: '50%',
        },
    },
    instructionAlertTooltipContainer: {
        position: 'absolute',
        transform: 'translateY(-50%)',
        '@media (max-width: 767px)': {
            transform: 'translateY(-50%) translateX(62%)',
        },
    },
    instructionAlertTooltip: {
        backgroundColor: theme_1.colors.grey80,
        padding: '4px 12px',
        borderRadius: 5,
        color: 'white',
        fontSize: 12,
    },
    readOnlyLabel: {
        marginLeft: 10,
    },
    readOnly: {
        color: theme_1.colors.grayDescription,
    },
    label: {
        paddingRight: 0,
    },
    chip: {
        display: 'inline-flex',
        padding: '2px 5px',
        alignItems: 'center',
        gap: 10,
        borderRadius: 10,
        color: theme_1.colors.coralRed,
        fontFamily: 'Roboto',
        fontSize: 9,
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        background: theme_1.colors.lavenderBlush,
        marginLeft: 6,
    },
    smallFontSize: {
        fontWeight: 500,
        fontSize: '14px !important',
        color: theme_1.colors.black0,
        display: 'contents',
    },
    errorTxt: {
        color: `${theme_1.colors.dangerFontColor} !important`,
    },
}));
const TGLabelWrapperWeb = props => {
    const { required, readOnly, label, info, tooltip, calculated, oneLine, error, style } = props;
    const [openInstructionAlert, setOpenInstructionAlert] = react_1.useState(false);
    const [stickyInstructionAlert, setStickyInstructionAlert] = react_1.useState(false);
    const [infotool, setInfotool] = react_1.useState(false);
    const labelStyles = useLabelStyles();
    const openTooltip = tooltip === true;
    const title = calculated ? 'This is a calculated field, and is therefore read only' : 'This field is read only';
    const ElementType = oneLine ? 'span' : 'div';
    return (react_1.default.createElement(ElementType, { className: oneLine ? undefined : '' },
        react_1.default.createElement(core_1.Tooltip, { title: title, placement: "right", open: openTooltip && infotool },
            react_1.default.createElement(ElementType, { className: oneLine ? undefined : [labelStyles.labelWrapper, style].join(' ') },
                react_1.default.createElement(ElementType, { className: clsx_1.default('labelWrapper-label', !info && labelStyles.label, readOnly && labelStyles.readOnly, labelStyles.smallFontSize, error && labelStyles.errorTxt) },
                    label ? label + (oneLine ? ': ' : '') : '',
                    required && react_1.default.createElement(core_1.Typography, { className: labelStyles.chip }, "Required"),
                    readOnly && !calculated && react_1.default.createElement(icons_1.ReadOnlyIcon, { className: labelStyles.readOnlyLabel }),
                    calculated && react_1.default.createElement(Iso_1.default, { fontSize: "small" })),
                info && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(core_1.IconButton, { size: "small", className: `${labelStyles.instruction} ${stickyInstructionAlert ? 'sticky' : ''}`, color: "primary", onMouseEnter: event => {
                            event.stopPropagation();
                            setOpenInstructionAlert(true);
                            setInfotool(false);
                        }, onMouseLeave: event => {
                            event.stopPropagation();
                            if (!stickyInstructionAlert) {
                                setOpenInstructionAlert(false);
                                setInfotool(true);
                            }
                        }, onClick: event => {
                            setStickyInstructionAlert(prev => !prev);
                        } },
                        react_1.default.createElement(Info_1.default, null)),
                    openInstructionAlert && (react_1.default.createElement("div", { className: labelStyles.instructionAlertContainer },
                        react_1.default.createElement("div", { className: labelStyles.instructionAlertTooltipContainer },
                            react_1.default.createElement(core_1.Tooltip, { title: "", placement: "right", className: labelStyles.instructionAlertTooltip },
                                react_1.default.createElement("div", null, info)))))))))));
};
exports.default = TGLabelWrapperWeb;
//# sourceMappingURL=TGLabelWrapperWeb.js.map